import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss']
})
export class DepartmentsComponent implements OnInit {
  departments$: Observable<any>
  private departments: any[]
  params: any
  
  constructor(
    private config: FilteredListConfig,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = {...params}
    })
    this.route.data.subscribe((data: {departments: any}) => {
      this.departments$ = data.departments
      this.departments = data.departments.data
      this.config.listItems = this.departments.map(department => {
        return {
          _id: null,
          title: department,
        }
      });
      this.config.count = this.departments.length
      this.config.page = 1
      this.config.limit = this.departments.length
      this.config.emitChanges()
    })
    this.config.title = 'Departments'
  }
}
